module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(" " + _vm._s(_vm.header) + " ")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.classlist), function(cl) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(cl.terms))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cl.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cl.school))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc7cdfcc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cv/teaching.vue
// module id = 204
// module chunks = 0